(function () {
  const selectors = {
    swiper: ".blog-posts-swiper-new",
  };

  if (!document.querySelector(selectors.swiper)) return;

  new Swiper(selectors.swiper, {
    slidesPerView: 1,
    spaceBetween: 40,
    pagination: {
      el: `${selectors.swiper} .swiper-pagination`,
      clickable: true,
    },
    navigation: {
      nextEl: `${selectors.swiper} .swiper-button-next`,
      prevEl: `${selectors.swiper} .swiper-button-prev`,
    },
  });
})();

(function () {
  const selectors = {
    swiper: ".social-proof-swiper",
  };

  if (!document.querySelector(selectors.swiper)) return;

  new Swiper(selectors.swiper, {
    slidesPerView: 1,
    spaceBetween: 40,
    pagination: {
      el: `${selectors.swiper} .swiper-pagination`,
      clickable: true,
    },
    navigation: {
      nextEl: `${selectors.swiper} .swiper-button-next`,
      prevEl: `${selectors.swiper} .swiper-button-prev`,
    },
  });
})();

(function ($) {
  $(document).ready(function () {
    
    $(document).on('click', '.new-faq__item__question', function() {
      $(this).parent().toggleClass('active');
      $(this).next().toggle(300);
    });

    $(document).on('click', '.new-footer-second-cl-list__head', function() {
      $(this).parent().toggleClass('active');
      $(this).next().toggle(300);
    });

    if($('.m-prod-section-upd').length) {
      $(document).on('click', '.loop-upd__selling-item', function() {
        let value = $(this).attr('value')
        $(`.m-prod-section-upd .loop-selling-plan-selector-option[value="${value}"]`).trigger('click');
        $('.m-prod-section-upd .loop-selling-plan-selector').val(`${value}`).trigger('change');
        $('.m-prod-section-upd input[name="selling_plan"]').val(value);
        $('.loop-upd__selling-item').removeClass('active');
        $(this).addClass('active');
      });

    }

    if($('.m-product-panels').length) {
      $(document).on('click', '.m-prod-panel__name', function() {
        $(this).parent().toggleClass('active');
        $(this).next().toggle(300);
      });
    }

    $(document).on('click', 'a[href="#recover"]', function() {
      $('#recover, #recover+div').show()
    });

     // if($('[data-template="product.updated"]').length) {
     //   $.initialize(".jdgm-sort-dropdown", function() {
     //     let current = $(this)
     //      setTimeout(function() { 
     //        var currentNew = document.querySelector('.jdgm-sort-dropdown');
     //        current.val('highest-rating')
     //        currentNew.value = 'highest-rating';
     //        var changeEvent = new Event('change');
     //        currentNew.dispatchEvent(changeEvent);
     //      } , 1000);
     //    });
     // }
  });
})(jQuery);
